import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HappyGuestSessionService } from '../services/happy/happy-guest-session.service';
import { HappyTenantContextService } from '../services/happy/happy-tenant-context.service';
import { SKIP_STORE_API_KEY } from './http-context-tokens';

export const happyApiHeadersInterceptor: HttpInterceptorFn = (req, next) => {
  const happyBaseUrl = environment.happyApi?.baseUrl || '';
  if (!happyBaseUrl || !req.url.startsWith(happyBaseUrl)) {
    return next(req);
  }

  const setHeaders: Record<string, string> = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  };
  const setParams: Record<string, string> = {};

  const tenantContext = inject(HappyTenantContextService);
  const tenant = tenantContext.tenant();
  const storeApiKey = tenantContext.storeApiKey();

  if (!req.params.has('tenant') && tenant) {
    setParams['tenant'] = tenant;
  }

  const skipStoreApiKey = req.context.get(SKIP_STORE_API_KEY);
  if (
    !skipStoreApiKey &&
    !req.params.has('store_api_key') &&
    storeApiKey
  ) {
    setParams['store_api_key'] = storeApiKey;
  }

  const hasAuthHeader =
    req.headers.has('Authorization') || req.headers.has('authorization');
  if (environment.happyApi?.useGuestSession && !hasAuthHeader) {
    const sessionService = inject(HappyGuestSessionService);
    setHeaders['X-Guest-Session-Id'] =
      sessionService.getOrCreateGuestSessionId();
  }

  return next(
    req.clone({
      setHeaders,
      setParams
    })
  );
};
